export const JOB_CODE_UNIT_COST_RESERVE = '1'
export const JOB_CODE_HIKIATE = '007'
export const JOB_CODE_RESPOND_WEB_REQUESTS = '014'
export const JOB_CODE_ARRIVAL_TRACKING = '015'
export const JOB_CODE_SALES_TRANSFER = '016'
export const JOB_CODE_CONTRACT_RESPONSE = '017'
export const JOB_CODE_WEB_LISTING = '008'
export const JOB_CODE_WEB_LISTING_INQUIRY = '009'
export const JOB_CODE_ONSITE_SALE = '018'
export const JOB_CODE_CONVERT_SALE_DATA = '019'
export const JOB_CODE_EXPORT_SHIPMENT_SLIP = '021'
export const JOB_CODE_ARRIVAL_INPUT = '001'
export const JOB_CODE_REMAINING_STOCKS_TRANSFER = '020'
export const JOB_CODE_PRINTER = '023'
export const JOB_CODE_ACCOUNT_PAYABLE = '107'
export const JOB_CODE_EXPORT_SHIKIRI = '120'
export const JOB_CODE_JOB_DATE = '033'
export const JOB_CODE_RED_SLIP_INQUIRY = '125'
export const JOB_CODE_ACCOUNT_RECEIVABLE = '124'
export const JOB_CODE_PAYMENT = '128'
export const JOB_CODE_DEPOSIT = '127'
export const JOB_CODE_BANK_TRANSFER = '129'
export const JOB_CODE_DAILY_UPDATE = '037'
export const JOB_CODE_ACCESS_LOGS = '131'

// ---------- NEW JOB CODE ----------------
export const JOB_CODE_MOBILE_SALES_INPUT = '088'
export const JOB_CODE_ACCOUNTING_BILL = '106'
export const JOB_CODE_SHIPPING_INCENTIVE = '109'
export const JOB_CODE_ACCOUNT_TRANSFER = '113'
export const JOB_CODE_REMIT = '115'
export const JOB_CODE_INPUT_DEFICIENCY_DATA = '118'
export const JOB_CODE_FAX_TRANSMISSION = '122'
export const JOB_CODE_ARRIVAL_LABEL_OUTPUT = '135'
export const JOB_CODE_EDI_ARRIVAL_RESERVE = '137'
export const JOB_CODE_REMARK_SCHEDULE = '140'
export const JOB_CODE_SERI_SALES_CANCEL = '139'

// -----------MASTER SCREEN JOB CODE--------
export const JOB_CODE_MASTER_SHIPPER = '045'
export const JOB_CODE_MASTER_CARRIER = '046'
export const JOB_CODE_MASTER_COUNTRY = '047'
export const JOB_CODE_MASTER_FREIGHT_COST = '048'
export const JOB_CODE_MASTER_AGRI_NEWS_CATEGORY = '049'
export const JOB_CODE_MASTER_SHIPPER_ITEM_DEFAULT = '050'
export const JOB_CODE_MASTER_ITEM = '051'
export const JOB_CODE_MASTER_GRADE = '052'
export const JOB_CODE_MASTER_BLOOM_NUM = '053'
export const JOB_CODE_MASTER_COLOR = '054'
export const JOB_CODE_MASTER_AGRI_ITEM = '055'
export const JOB_CODE_MASTER_ARTICLE = '056'
export const JOB_CODE_MASTER_UNIT = '057'
export const JOB_CODE_MASTER_PACKING = '058'
export const JOB_CODE_MASTER_CATEGORY = '059'
export const JOB_CODE_MASTER_MPS = '060'
export const JOB_CODE_MASTER_ESTABLISHER_ITEM = '061'
export const JOB_CODE_MASTER_BUYER = '062'
export const JOB_CODE_MASTER_BUYER_ACCOUNT = '063'
export const JOB_CODE_MASTER_CONVERSION_SHIPPER = '064'
export const JOB_CODE_MASTER_CONVERSION_COUNTRY = '065'
export const JOB_CODE_MASTER_CONVERSION_PACKING = '066'
export const JOB_CODE_MASTER_CONVERSION_GRADE = '098'
export const JOB_CODE_MASTER_CONVERSION_VARIETY = '099'
export const JOB_CODE_MASTER_VARIETY_SHIPPER_FILE = '067'
export const JOB_CODE_MASTER_DEPARTMENT = '068'
export const JOB_CODE_MASTER_INDUSTRY = '069'
export const JOB_CODE_MASTER_MEMBER = '070'
export const JOB_CODE_MASTER_ROLE = '071'
export const JOB_CODE_MASTER_SETTING = '072'
export const JOB_CODE_MASTER_COMMENT = '073'
export const JOB_CODE_MASTER_MARKET_CONDITIONS = '074'
export const JOB_CODE_MASTER_COMPANY_BANK = '075'
export const JOB_CODE_MASTER_TAKE_EARLY_POS = '076'
export const JOB_CODE_MASTER_COMPANY_ACCOUNT_DEBIT = '077'
export const JOB_CODE_MASTER_BANK = '078'
export const JOB_CODE_MASTER_MARKET_COMMISSION = '079'
export const JOB_CODE_MASTER_BID_PRICE = '080'
export const JOB_CODE_MASTER_CLOSING_DATE = '083'
export const JOB_CODE_MASTER_BANK_CALENDAR = '081'
export const JOB_CODE_MASTER_FLORIS_SEND = '082'
export const JOB_CODE_MASTER_PRODUCT_FILE = '084'
export const JOB_CODE_MASTER_DEVICE = '101'
export const JOB_CODE_MASTER_LOGIN = '085'
export const JOB_CODE_MASTER_BANK_BRANCH = '095'
export const JOB_CODE_MASTER_VARIETY = '094'
export const JOB_CODE_MASTER_AUCTION_GROUP = '134'
